import axios from 'axios'
import authStore from '@/store/auth'

const UNAUTHORIZED = 401
const FORBIDDEN = 403

const onUnauthorized = () => {
    authStore.dispatch('logout')
        .then(() => {
            console.log('logout')
        })
        .catch(() => {
        })
}

export const setAuthInHeader = (token) => {
    axios.defaults.headers.common['Authorization'] = token ? `${token}` : null;
}

if (authStore.state.authInfo.token !== null) {
    setAuthInHeader(authStore.state.authInfo.token)
} else {
}

const getRequest = (url, data) => {
    return axios.get((isValidUrl(url)) ? url : url, { params: data })
        .then(result => {
            if (result.data.code === "J0000") {
                return result.data
            } else {
                throw result.data
            }
        })
        .catch(result => {
            console.log('getRequest :', result.response)
            if (result.response.status === UNAUTHORIZED || result.response.status === FORBIDDEN) {
                onUnauthorized()
                console.log('onUnauthorized :', url)
                throw { isAlert: false }
            } else {
                throw { isAlert: true, result: result.response }
            }
        })
}

const postRequest = (url, data) => {
    return axios.post(url, data, {headers: {
            "Content-Type": `application/json`,
        }})
        .then(result => {
            if (result.data.code === "J0000") {
                return result.data
            } else {
                throw result.data
            }
        })
        .catch(result => {
            console.log('postRequest :', result.response)
            if (result.response.status === UNAUTHORIZED || result.response.status === FORBIDDEN) {
                onUnauthorized()
                console.log('onUnauthorized :', url)
                throw { isAlert: false }
            } else {
                throw { isAlert: true, result: result.response.data }
            }
        })
}

const isValidUrl = urlString=> {
    var urlPattern = new RegExp('^(https?:\\/\\/)?');
    return !!urlPattern.test(urlString);
}

export const auth = {
    sendSMS(phone_number) {
        return postRequest('/api/auth/send_auth_number', { phone_number })
    },
    login(phone_number, sms_auth_number) {
        return postRequest('/api/auth/login', { phone_number, sms_auth_number })
    },
    isAuth() {
        return postRequest('/api/auth/is_auth')
    },
    getMembershipInfo(corp) {
        return postRequest('/api/auth/membership/list', { corp })
    },
    getDiscountMembershipInfo(corp, upjang_code) {
        return postRequest('/api/auth/membership/discount/list', { corp, upjang_code})
    }
}

export const common = {
    getCommonCode(corp_code, head_array) {
        return postRequest('/api/information/common_code/list', { corp_code, head_array })
    },
}

export const main = {
    getNoticeList(corp_code, notice_type) {
        return postRequest('/api/information/notice/list', { corp_code, notice_type })
    },
    getUserSummary(corp, corp_code) {
        return postRequest('/api/auth/summary', { corp, corp_code })
    },
}

export const upjang = {
    getUpjangInfo(corp_code, upjang_code) {
        return postRequest('/api/order/upjang', { corp_code, upjang_code })
    },
    getUpjangList(corp_code, upjang_div) {
        return postRequest('/api/order/upjang/list', { corp_code, upjang_div })
    },
    getMenuGroupList(corp_code, upjang_code) {
        return postRequest('/api/order/upjang/menu_group/list', { corp_code, upjang_code })
    },
    getMenuList(corp_code, upjang_code, upjang_mgrp_cd) {
        return postRequest('/api/order/upjang/menu/list', { corp_code, upjang_code, upjang_mgrp_cd })
    },
    getMenuInfo(corp_code, upjang_code, menu_code) {
        return postRequest('/api/order/upjang/menu/info', { corp_code, upjang_code, menu_code })
    },
}

export const cart = {
    updateAddedCartItem(corp_code, upjang_code, menu_code, sale_cnt, cart_key) {
        return postRequest('/api/order/cart/added_item', {corp_code, upjang_code, menu_code, sale_cnt, cart_key})
    },
    updateCart(corp_code, upjang_code, menu_code, sale_cnt, cart_key) {
        return postRequest('/api/order/cart/item', {corp_code, upjang_code, menu_code, sale_cnt, cart_key})
    },
    removeCartItem(corp_code, cart_key, seq_no, menu_code) {
        return postRequest('/api/order/cart/remove/item', {corp_code, cart_key, seq_no, menu_code})
    },
    getCartItemList(corp_code, cart_key) {
        return postRequest('/api/order/cart/item/list', {corp_code, cart_key})
    },
    checkCart(corp_code, cart_key) {
        return postRequest('/api/order/cart/validate', {corp_code, cart_key})
    },
}

export const order = {
    makeOrderInfo(request) {
        return postRequest('/api/order/bill/make', request)
    },
    cancelOrderInfo(request) {
        return postRequest('/api/order/bill/cancel', request)
    },
    getOrderInfo(corp_code, sale_date, bill_no, upjang_code) {
        return postRequest('/api/order/info', { corp_code, sale_date, bill_no, upjang_code })
    },
    getOrderInfoList(corp_code, search_date_start, search_date_end, search_status) {
        return postRequest('/api/order/list', { corp_code, search_date_start, search_date_end, search_status })
    },
    getOrderPrice(corp_code, cart_key, dc_info) {
        return postRequest('/api/order/price', { corp_code, cart_key, dc_info })
    },
}

export const ticket = {
    getHavingTicketList(corp, brch) {
        return getRequest('/api/ticket/list', { corp, brch })
    },
    getHavingTicket(corp, brch, tktorgno) {
        return getRequest('/api/ticket', { corp, brch, tktorgno })
    },
    useTicket(corp, brch, tktype, tktno, tktorgno, validto, tk_name, use_pincode) {
        return postRequest('/api/ticket/use', { corp, brch, tktype, tktno, tktorgno, validto, tk_name, use_pincode })
    },
}

export const shortUrl = {
    search(short_url) {
        return postRequest('/api/origin_url', short_url)
    }
}

export const util = {
    writeLog(uri) {
        return postRequest('/api/not_found_path', {uri})
    }
}